import api from "@helpers/api";
import { t } from "@i18n";

/**
 * `POST content/upload-url` — presigns a PUT for a lesson video.
 *
 * `final_url` is the uploaded file itself (the .mp4 / .mov), so it only exists
 * once the PUT to `upload_url` has returned 2xx.
 *
 * @param {File} file
 * @returns {Promise<{ upload_url: string, final_url: string }>}
 */
export async function requestVideoUploadUrl(file) {
    const { data } = await api.post("content/upload-url", {
        filename: file.name,
        content_type: file.type,
        extension: file.name.split(".").pop(),
    });

    if (!data?.upload_url || !data?.final_url) {
        throw new Error(t("content:videoUpload.urlError"));
    }

    return data;
}
